import React from 'react';

import ReactDOM from 'react-dom';

import './index.css';

import App from './App';

import reportWebVitals from './reportWebVitals';

import { PublicClientApplication } from "@azure/msal-browser"

import { loginRequest, msalConfig } from "./authconfig";

import { MsalProvider } from '@azure/msal-react';

import axios from 'axios'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Provider } from "react-redux";
import Store from "./Store";

/* The jQuery DataTables plugin, for the whole app.
   Fourteen pages call $(...).DataTable() — Allergies, Previous Pregnancy,
   Previous Fertility Treatment, Previous Procedure, Prescription, Drug
   Reminder, Appointment, Conditions, Case, Checklist, Knowledge Base … — but
   the plugin used to be loaded by ONE of them, TreatmentWithUs.js, and only
   worked everywhere because that file happened to be bundled. When that page
   stopped using DataTables and dropped the import, every one of the others
   broke: "$(...).DataTable is not a function", thrown before their data was
   fetched. It is loaded here, once, so no page depends on another's imports.
   Before theme.css, so the theme's DataTables styling still wins. */
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";

/* Design-system layer. Imported last so it wins the cascade against the
   legacy template stylesheet and the per-page CSS files. */
import "./theme/theme.css";
/* Clinical OX.ar look for the overview and medical history pages. */
import "./theme/clinical.css";

/**************INTERCEPTORS*******************************/

// Add a request interceptor

axios.interceptors.request.use(

  config => {
    const token = sessionStorage.getItem("AuthToken")
    if (token) {     
      config.headers['Authorization'] = 'Bearer ' + token
      config.headers['Strict-Transport-Security'] = 'max-age=31536000; includeSubDomains;'
      config.headers['Content-Security-Policy'] = "default-src 'self'; style-src 'self' 'unsafe-inline'"
      config.headers['X-Frame-Options'] = "SAMEORIGIN"
      config.headers['X-XSS-Protection'] = '1; mode=block'
      config.headers['X-Content-Type-Options'] = 'nosniff'
    }

    return config
  },

  error => {
    Promise.reject(error)
  }

)
const msalInstance = new PublicClientApplication(msalConfig);

const AppProvider = () => (
  <React.StrictMode>
    <Provider store={Store}>
      <MsalProvider instance={msalInstance}>
        {/* Check */}
        
          <App></App>

      </MsalProvider>
    </Provider>
  </React.StrictMode>
);

ReactDOM.render(<AppProvider />, document.getElementById('root'))
reportWebVitals();